import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=683cfab0"
import script from "./UserRoles.vue?vue&type=script&lang=js"
export * from "./UserRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683cfab0')) {
      api.createRecord('683cfab0', component.options)
    } else {
      api.reload('683cfab0', component.options)
    }
    module.hot.accept("./UserRoles.vue?vue&type=template&id=683cfab0", function () {
      api.rerender('683cfab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/UserRoles.vue"
export default component.exports